import React from "react";

/**
 * Gruppo di filtri a "chip": un clic seleziona, quello attivo è evidenziato.
 * Usato in modo uniforme dal catalogo pubblico e dalla gestione corsi admin.
 *
 * options: [{ value, label }]  ·  value: valore selezionato  ·  onChange(value)
 */
export default function ChipGroup({ options, value, onChange, testid, ariaLabel }) {
  return (
    <div
      className="flex flex-wrap gap-2"
      data-testid={testid}
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            aria-pressed={active}
            data-testid={testid ? `${testid}-${o.value}` : undefined}
            className={
              "text-sm font-medium px-3 py-1.5 rounded-sm border transition-colors " +
              (active
                ? "bg-brand-blue text-white border-brand-blue"
                : "bg-white text-brand-muted border-brand-line hover:border-brand-blue/40 hover:text-brand-blue")
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
